module.exports = __webpack_public_path__ + "static/images/verify-your-pickup-address.3MZfdU3.svg";